module.exports = __webpack_public_path__ + "media/images/IMG1_usecases_preview-01ff4470.png";